import { render, staticRenderFns } from "./InboundShipments.vue?vue&type=template&id=736451fe&scoped=true"
import script from "./InboundShipments.vue?vue&type=script&lang=js"
export * from "./InboundShipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736451fe",
  null
  
)

export default component.exports